module.exports = {
  apiHost: "https://api.project.sensoreal.com.au",
  assetsHost: "https://assets.project.sensoreal.com.au",
  brandName: "Project Name",

  // Must match a file in src/form-templates/fields.{formTemplate}.js.
  formTemplate: "default",

  currency: {
    locale: "en-AU",
    code: "AUD",
  },

  langs: [{ code: "en", dir: "ltr" }],

  style: {
    primaryColor: "#000",
    textColor: "#fff",

    // Primary page/header font. Must be a system font, imported web font,
    // or a font declared in src/assets/styles/_fonts.scss.
    font: "Nexa",

    // Optional background for header/footer. Falls back to primaryColor.
    backgroundGradient: "",

    // Controls favourites body copy, property card details, buttons, and footer text.
    // If empty, secondaryFont falls back to font above.
    secondaryFont: "",

    // Optional external stylesheet, for example a Google Fonts URL.
    secondaryFontStylesheet: "",
  },

  header: {
    text: {
      en: "Your Favourite Selections",
      ar: "",
    },

    logo: false,
    // Optional max size overrides for header.logo. Use CSS values like "150px".
    logoMaxWidth: "",
    logoMaxHeight: "",

    // Optional right-side logo in the header.
    companyLogo: false,
    companyLogoMaxWidth: "",
    companyLogoMaxHeight: "",

    // Optional title font-size override. Use CSS values like "24px".
    titleFontSize: "",

    color: "#fff",
  },

  footerLogo: false,

  // "top" or "bottom". Empty/default renders the logo at the top.
  footerLogoPosition: "",

  // Optional max-width override for footerLogo. Use CSS values like "180px".
  footerLogoMaxWidth: "",

  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "",
  },

  contact: {
    website: "",
    address: "",
    phone: "",
    email: "",
  },
};
